import { c as _c } from "react/compiler-runtime";
import { CicStatement } from "@/entities/IProfile";
import UserPageIdentityStatementsStatementsList from "../utils/UserPageIdentityStatementsStatementsList";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageIdentityStatementsNFTAccounts(t0) {
  const $ = _c(6);
  const {
    statements,
    profile,
    loading
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-items-center tw-space-x-4"><div className="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-950 tw-border tw-border-solid tw-border-iron-800"><div className="tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-100"><svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-100" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M16 5L18 7L22 3M22 12V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.7202 22 18.8802 22 17.2 22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H12M2.14551 19.9263C2.61465 18.2386 4.16256 17 5.99977 17H12.9998C13.9291 17 14.3937 17 14.7801 17.0769C16.3669 17.3925 17.6073 18.6329 17.9229 20.2196C17.9998 20.606 17.9998 21.0707 17.9998 22M14 9.5C14 11.7091 12.2091 13.5 10 13.5C7.79086 13.5 6 11.7091 6 9.5C6 7.29086 7.79086 5.5 10 5.5C12.2091 5.5 14 7.29086 14 9.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div></div><span className="tw-text-base tw-font-semibold tw-text-iron-100">NFT Accounts</span></div>;
    t2 = <div className="tw-mt-3 tw-h-px tw-bg-white/5 tw-w-full" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== loading || $[3] !== profile || $[4] !== statements) {
    t3 = <div>{t1}{t2}<UserPageIdentityStatementsStatementsList statements={statements} profile={profile} noItemsMessage="No NFT Account added yet" loading={loading} /></div>;
    $[2] = loading;
    $[3] = profile;
    $[4] = statements;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}